module.exports = __webpack_public_path__ + "static/img/logo.57435bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.jpg
// module id = 4Uwr
// module chunks = 24